import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Download, Loader2, Share2, X } from "lucide-react";
import { api, BACKEND_URL, formatApiError } from "../../lib/api";

const file = (p) => `${BACKEND_URL}/api/files/${p}`;

async function blobOf(path) {
  const r = await fetch(file(path));
  return r.blob();
}

function KitImage({ label, path, name }) {
  const save = async () => {
    const b = await blobOf(path);
    const a = document.createElement("a");
    a.href = URL.createObjectURL(b);
    a.download = name;
    a.click();
    URL.revokeObjectURL(a.href);
  };
  const share = async () => {
    const f = new File([await blobOf(path)], name, { type: "image/jpeg" });
    if (navigator.canShare?.({ files: [f] })) navigator.share({ files: [f] }).catch(() => {});
    else save();
  };
  const testid = label.toLowerCase().split(" ")[0];
  return (
    <div className="space-y-2" data-testid={`kit-${testid}`}>
      <p className="text-[10px] uppercase tracking-[0.2em] text-[var(--muted)]">{label}</p>
      <img src={file(path)} alt={label} className="w-full rounded-xl border border-[var(--line)]" />
      <div className="grid grid-cols-2 gap-2">
        <button onClick={save} className="btn-outline-gold !py-1.5 !px-2 text-xs inline-flex items-center justify-center gap-1" data-testid={`kit-download-${testid}`}><Download className="w-3.5 h-3.5" />Download</button>
        <button onClick={share} className="btn-gold !py-1.5 !px-2 text-xs inline-flex items-center justify-center gap-1" data-testid={`kit-share-${testid}`}><Share2 className="w-3.5 h-3.5" />Share</button>
      </div>
    </div>
  );
}

export function ShareKit({ photoId, onClose }) {
  const [k, setK] = useState(null);
  useEffect(() => {
    api.get(`/invite-photos/${photoId}/kit`).then((r) => setK(r.data)).catch((e) => { toast.error(formatApiError(e)); onClose(); });
  }, [photoId, onClose]);
  const copy = () => navigator.clipboard.writeText(k.caption).then(() => toast.success("Caption copied"));
  return (
    <div className="fixed inset-0 z-[95] bg-black/70 backdrop-blur-md flex items-center justify-center p-4" onClick={onClose} data-testid="share-kit">
      <div onClick={(e) => e.stopPropagation()} className="relative bg-[var(--bg)] rounded-3xl w-full max-w-3xl max-h-[92dvh] overflow-y-auto p-6 md:p-8">
        <button onClick={onClose} aria-label="Close" className="absolute top-4 right-4 w-9 h-9 rounded-full bg-black/5 flex items-center justify-center hover:bg-black/10 transition-colors" data-testid="share-kit-close"><X className="w-4 h-4" /></button>
        <p className="font-serif text-3xl">Your share kit</p>
        <p className="text-sm text-[var(--muted)] mt-1 mb-6">Post it on TikTok and Instagram with {k?.tag || "#lockedinforever"} to spread the trend.</p>
        {!k ? <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-[var(--gold)]" /></div> : <>
          <div className="grid sm:grid-cols-[0.8fr_1fr] gap-6 items-start">
            <KitImage label="TikTok & Reels / Stories" path={k.story} name="lockedinforever-story.jpg" />
            <KitImage label="Instagram post" path={k.post} name="lockedinforever-post.jpg" />
          </div>
          <div className="mt-6 bg-white border border-[var(--line)] rounded-2xl p-4">
            <p className="text-[10px] uppercase tracking-[0.2em] text-[var(--muted)] mb-2">Caption</p>
            <p className="text-sm whitespace-pre-line" data-testid="share-kit-caption">{k.caption}</p>
            <button onClick={copy} className="btn-outline-gold !py-1.5 text-xs mt-3 inline-flex items-center gap-1" data-testid="share-kit-copy"><Copy className="w-3.5 h-3.5" />Copy caption</button>
          </div>
          <div className="flex flex-wrap gap-3 mt-5 text-sm">
            <a href="https://www.tiktok.com/upload" target="_blank" rel="noreferrer" className="underline text-[var(--gold)]" data-testid="share-kit-tiktok">Open TikTok</a>
            <a href="https://www.instagram.com/" target="_blank" rel="noreferrer" className="underline text-[var(--gold)]" data-testid="share-kit-instagram">Open Instagram</a>
          </div>
        </>}
      </div>
    </div>
  );
}
